import React from 'react';

import {
  Icon,
  ListItemComp,
  ListItemCompAction,
  ListItemCompContent,
  ListItemCompLeading,
  ListItemCompTitle,
  Reset as ResetIcon,
  Button,
} from '@mesh.ai/rabbit';
import { useDispatch } from 'react-redux';

import { resetDefaultNotificationSettingsForEmployees } from 'services/admin';
import { showErrorSnackbar, showSuccessSnackbar } from 'services/snackbar';

import { PaperWithShadow } from 'uiToolkitV1/Paper';

export const NotificationSettingsFooter = ({
  isEmployeeNotificationSettings = false,
  refreshData,
}: {
  isEmployeeNotificationSettings?: boolean;
  refreshData: () => void;
}) => {
  const dispatch = useDispatch();

  const resetToDefaultSettingsHandler = () => {
    resetDefaultNotificationSettingsForEmployees()
      .then(() => {
        refreshData();
        // @ts-expect-error ts issue
        dispatch(showSuccessSnackbar('Settings reset successful!'));
      })
      .catch((err) => {
        // @ts-expect-error ts issue
        dispatch(showErrorSnackbar('Error in resetting'));
        console.error('Error resetting notification settings : ', err);
      });
  };

  if (!isEmployeeNotificationSettings) {
    return null;
  }

  return (
    <PaperWithShadow padding="0 12px" margin="12px 0">
      <ListItemComp>
        <ListItemCompLeading>
          <Icon IconSVG={ResetIcon} />
        </ListItemCompLeading>
        <ListItemCompContent>
          <ListItemCompTitle bold={false}>Reset to my organization&apos;s default settings</ListItemCompTitle>
        </ListItemCompContent>
        <ListItemCompAction>
          <Button variant="outline" onClick={() => resetToDefaultSettingsHandler()}>
            Reset
          </Button>
        </ListItemCompAction>
      </ListItemComp>
    </PaperWithShadow>
  );
};
